<template>
    <div class="container">
        <c-header></c-header>
        <div class="body-content">
            <div class="left-content">
                <ul class="posts">
                    <loading v-show="showLoading"></loading>

                    <li class="border" v-for="article in listArticles" :key="'article-' + article.id">
                        <div class="post-header">
                            <h2 @click="detail(article.id)">{{ article.title }}</h2>
                        </div>
                        <div class="post-body">
                            <p class="title-nav" style="border-bottom:none;">
                                <strong>作者: {{ article.author }}</strong>
                            </p>
                        </div>
                        <div class="post-footer">
                            <!-- <div class="tags">Tag：<a href="#">-</a></div> -->
                            <div class="menubar">
                                <span class="author">
                                    <a>{{ article.sourceText }}</a>
                                </span> 
                                发表于
                                <span class="time">{{ formatDateCode(article.publishDate) }}</span> 
                                | 
                                <a @click="detail(article.id)" class="readmore">阅读全文</a> 
                            </div>
                        </div>
                    </li>
                </ul>
                <c-page :current="current"
                    :showItem="showItem"
                    :allpage="allpage"
                    :allcount="allcount"
                    @setPage="setPage"></c-page>
            </div>    
            <div class="sidebar">
                <div id="profile" class="module">
                    <h2>个人资料</h2>
                    <div class="mod-body"> 
                        <a :href="homePage"><img class="avatar" :src="require('assets/images/avatar.jpg')"></a>
                        <h3 class="author"><a :href="homePage">汉江博客</a></h3>
                        <div class="about">生存之道，乃修仙之道，不断学习，不断升级!</div>
                    </div>
                </div>
                <div class="search module">
                    <div class="modTop"></div>
                    <h2>搜索</h2>
                    <div class="mod-body">
                        <input type="text" v-model="q" @keyup.enter="search()" class="text-field">
                        <input type="button" @click="search()" class="button" value="搜索">
                        <div class="clear"></div>
                    </div>
                </div>
                <div class="calendar module">
                    <h2>日历</h2>
                    <div class="mod-body">
                        <c-calendar></c-calendar>
                    </div>
                </div>
                <div id="cats" class="module">
                    <h2>文章分类</h2>
                    <div class="mod-body">
                        <ul>
                            <li><a href="#">Linux<span class="count">[10]</span></a></li>
                            <li><a href="#">PHP<span class="count">[10]</span></a></li>
                            <li><a href="#">Python<span class="count">[10]</span></a></li>
                            <li><a href="#">MySQL<span class="count">[10]</span></a></li>
                            <li><a href="#">其他<span class="count">[10]</span></a></li>
                        </ul>
                    </div>
                </div>
                <div id="nPosts" class="module">
                    <h2>最新文章</h2>
                    <div class="mod-body">
                        <ul v-if="lastNewArticles.length">
                            <li v-for="article in lastNewArticles"
                                :article="article"
                                :key="article.id">
                                <a @click="detail(article.id)">{{ article.title }}</a>
                            </li>
                        </ul>
                        <div class="more"><a :href="homePage">全部文章&gt;&gt;</a></div>
                    </div>
                </div>
                <div id="archives" class="module">
                    <h2>好东西分享</h2>
                    <div class="mod-body">
                        <ul>
                            <li><a href="/color.html">[配色表]</a></li>
                            <li><a target="_blank" href="https://www.cnblogs.com/liuxianan/p/chrome-plugin-develop.html">[Chrome插件(扩展)开发]</a></li>
                            <li><a target="_blank" href="http://ts.xcatliu.com">[TypeScript]</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        <c-footer></c-footer>
    </div>
</template>

<script>
    import Loading from '@/components/Loading'
    import CPage from '@/page/CPage'
    import CHeader from '@/page/CHeader'
    import CFooter from '@/page/CFooter'
    import CCalendar from '@/page/CCalendar'

    import {mapState} from 'vuex'


    export default {
        name: 'Main',
        components: {
            CPage,
            CHeader,
            CFooter,
            CCalendar
        },
        directives: {
        },
        data() {
            return {
                q: '',//搜索关键词
                listArticles: [],
                lastNewArticles: [],
                current: 1,
                showItem: 8,
                allpage: 0,
                allcount: 0
            }
        },
        computed: {
            ...mapState(['showLoading']),
            homePage() {
                return location.origin //主页地址
            }
        },
        methods: {
            search: function() {
                var _this = this;
                this.$apicall.post('api.Article.finds', {
                    titleLike: this.q,
                    page: this.current,
                    rowsPerPage: this.showItem
                })
                .then((response) => {
                    if(response.status == 200)
                    {
                        _this.listArticles.splice(0, _this.listArticles.length);
                        let listArticles = response.data.results;
                        for(let i=0; i< listArticles.length; i++) {
                            _this.listArticles.push(_this.dcontent(listArticles[i]))
                        }
                        _this.current = response.data.pagination.page;
                        _this.allpage = response.data.pagination.totalPage;
                        _this.allcount = response.data.pagination.totalCount;    
                    }
                })
                .catch((err)=>{
                    // _this.showToast(err.message)
                })
            },
            setPage: function(page) {
                this.current = page
                this.search()
            },
            detail: function(id) {
                this.$router.push({name: 'article', params: {id}})
            },
            dcontent: function(text) {
                return JSON.parse(this.$util.gzipDecode(text));
            },
            formatDateCode: function(date) {
                 if(! date) return '';
                return this.$util.timeFormat(new Date(date.replace(/(\d{4})(\d{2})(\d{2})/, "$1/$2/$3")), "yyyy-MM-dd");
            }
        },
        mounted() {
            var _this = this;
            this.$apicall.post('api.batch.request', {
                "requests": [
                    {
                        ck: 'listArticles',// 文章列表
                        api: 'api.Article.finds',
                        params:{
                            page: this.current,
                            rowsPerPage: this.showItem
                        }
                    },
                    {
                        ck: 'lastNewArticles',//最新文章
                        api: 'api.Article.finds',
                        params:{
                            orderBy: 'timeCreated DESC',
                            limit: 5
                        }
                    }
                ]
            })
            .then((response) => {
                if(response.status == 200)
                {
                    let results = response.data.results

// console.log(results)
                    if(results.listArticles.ErrorCode == '9999')
                    {
                        // 带分页
                        let listArticles = results.listArticles.Data.Results;
                        for(let i=0; i< listArticles.length; i++) {
                            _this.listArticles.push(_this.dcontent(listArticles[i]))
                        }
                        _this.allpage = results.listArticles.Data.Pagination.totalPage;
                        _this.allcount = results.listArticles.Data.Pagination.totalCount;
                    }
                    if(results.lastNewArticles.ErrorCode == '9999')
                    {
                        let lastNewArticles = results.lastNewArticles.Data.Results;
                        for(let i=0; i< lastNewArticles.length; i++) {
                            _this.lastNewArticles.push(_this.dcontent(lastNewArticles[i]))
                        }
                    }
                }
            })
            .catch((err)=>{
                // _this.showToast(err.message)
            })

        }
    }
</script>

<style>
.post-header h2{cursor: pointer; display: inline-block;}
</style>